<template>
  <div
    class="add-cofig-form"
  >
    <template v-if="type==='add'">
      <div class="add-collect-btn">
        <a-button
          v-show="!isShow"
          class="create-org-btn"
          @click="createOrg"
        >
          <i
            class="icon iconfont iconicon-test10"
          />
          {{ $t('message["1350"]') }}
        </a-button>
      </div>
    </template>
    <template v-else>
      <a
        v-show="!isShow"
        class="edit-collect-btn"
        @click="createOrg"
      >
        {{ $t('message["36"]') }}
      </a>
    </template>
    <a-form
      v-if="isShow"
      :form="form"
      layout="inline"
      class="demo-form-inline"
      @submit.prevent="creatOrgHandle"
    >
      <a-form-item
        class="total-input-box"
      >
        <a-input
          v-decorator="['fieldname',
                        {rules: [{ required: true, message: noEmpty },{validator: isNameRe}], initialValue:dataInfo.fieldname || ''}]"
          maxlength="30"
          :placeholder="enterPlaceholder"
          @change="inputChange"
        />
        <span class="input-length-num">{{ form.getFieldValue('fieldname')?form.getFieldValue('fieldname').length : 0 }}/30</span>
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          class="sub-btn"
        >
          {{ $t('message["915"]') }}
        </a-button>
        <a-button @click="resetForm">
          {{ $t('message["896"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
  },
  props: {
    dataInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShow: false,
      submiting: false,
      orgNameLen: 0,
      comname: ''
    }
  },
  computed: {
    ...mapState('config/referrer', ['submitting', 'datas', 'datasReady']),
    noEmpty () {
      return this.$t('message["67"]')
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapMutations('config/collect', ['']),
    createOrg () {
      this.isShow = true
      if (this.type === 'edit') {
        this.$emit('addEdit')
      }
    },
    creatOrgHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.isShow = false
          if (this.type === 'add') {
            this.datas.push({
              fieldname: this.form.getFieldValue('fieldname'),
              enabledelete: 1,
              fieldkey: '',
              child: [{
                fieldname: this.$t('message["541"]'),
                fieldtype: 'select',
                enabledelete: 0,
                isneeded: 0,
                isenable: 1,
                ischangeenable: 1,
                ischangename: 1,
                ischangeneeded: 1,
                ischangetype: 0,
                options: [],
                _id: (Math.random() * 10000000).toString(16).substr(0, 4) + '-' + (new Date()).getTime()
              }
              ],
              ischangename: 1
            })
            // this.setDatas(this.datas)
          } else {
            this.dataInfo.fieldname = this.form.getFieldValue('fieldname')
          }
          this.$emit('addEdit')
        }
      })
    },
    resetForm () {
      this.isShow = false
      this.$emit('addEdit')
    },
    getValLen (val) {
      let str = val.replace(/^\s+|\s+$/g, '')
      this.orgNameLen = str.length
    },
    isNameRe (rule, value, callback) {
      const length = this.datas.filter(item => item.fieldname === value).length
      const len = this.type === 'add' ? 0 : 1
      if (length > len) {
        callback(new Error(this.$t('message["58"]')))
      } else {
        callback()
      }
    },
    inputChange (e) {
      const val = (e.target.value).trim()
      // this.itemData.fieldname = val
      // console.log(val)
      this.$nextTick(() => {
        this.form.setFieldsValue({
          'fieldname': val
        })
        this.form.validateFields(['fieldname'])
      })
    }

  }
}
</script>

<style lang="scss" scoped>
  .add-cofig-form {
    display: inline;
    .sub-btn {
      margin-right: 16px;
    }
    .add-collect-btn {
      border-top: 1px solid #ebebeb;
      padding-top: 8px;
      .iconicon-test10 {
      color: #ccc;
      font-size: 16px;
      margin-right: 6px;
    }
    }
    .edit-collect-btn {
      margin-right: 16px;
    }
    .total-input-box {
      position: relative;
      .input-length-num {
       position: absolute;
       right: 10px;
    }
    }
  }
</style>
